<template>
  <v-data-table
    :headers="headers"
    :items="value.list"
    :options.sync="value.options"
    :hide-default-footer="value.serverItemsLength > 10 ? false : true"
    :server-items-length="value.serverItemsLength"
    :loading="value.loading"
    class="elevation-0"
  >
    <template v-slot:item.fullName="{ item }">
      <router-link
        :to="{
          name: 'users.edit',
          params: {
            id: item.id,
          },
        }"
      >
        {{ item.fullName }}
      </router-link>
    </template>

    <template v-slot:item.phone="{ item }">
      {{ formatPhoneNumber(item.phone) }}
    </template>

    <template v-slot:item.actions="{ item }">
      <div class="text-no-wrap">
        <v-tooltip
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              icon
              :to="{ name: 'users.edit', params: { id: item.id } }"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <span>
            Editovat
          </span>
        </v-tooltip>

        <v-tooltip
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              icon
              @click="deleteItemAction(item)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>

          <span>
            Smazat
          </span>
        </v-tooltip>
      </div>
    </template>

    <template v-slot:item.actionDeactivate="{ item }">
      <v-tooltip
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-on="on"
            v-bind="attrs"
            icon
            @click="changeBannedStatus(item)"
          >
            <v-icon
              :color="
                `${item.banned === true ? 'rgb(183, 15, 10)' : 'rgb(114, 187, 83)'}`
              "
              >mdi-account-circle</v-icon
            >
          </v-btn>
        </template>

        {{ item.banned ? 'Odblokovat' : 'Zablokovat' }}
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from 'vuex';
import { notifyDeleteUser } from '@/components/mixins/notifyDeleteUser';
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber';

export default {
  name: 'UserList',
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [notifyDeleteUser, formatPhoneNumber],
  data() {
    return {
      headers: [
        {
          text: 'Jméno',
          value: 'fullName',
        },
        {
          text: 'E-mail',
          value: 'email',
        },
        {
          text: 'Telefon',
          value: 'phone',
          width: '140px',
        },
        {
          text: 'Blokace',
          value: 'actionDeactivate',
          sortable: false,
        },
        {
          text: 'Editace',
          value: 'actions',
          sortable: false,
          align: 'right',
          width: '1px',
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      setDealerBannedStatus: 'users/setDealerBannedStatus',
      deleteDealer: 'users/deleteDealer',
    }),
    deleteItemAction(item) {
      this.$root.$confirmationDialog
        .open(`Chcete obchodníka ${item.fullName} opravdu odstranit?`, null)
        .then((resolve) => {
          if (resolve) {
            this.deleteDealer(item).then(() => {
              this.notifyDeleteUser(item);
              this.$emit('onChangeOptions', this.value);
            });
          }
        });
    },
    changeBannedStatus(item) {
      let dialogTitle = `Chcete obchodníka ${item.fullName} opravdu zablokovat?`;

      if (item.banned) {
        dialogTitle = `Chcete obchodníka ${item.fullName} opravdu odblokovat?`;
      }

      this.$root.$confirmationDialog.open(dialogTitle, null).then((resolve) => {
        if (resolve) {
          this.setDealerBannedStatus(item).then(() => {
            this.$emit('onChangeOptions', this.value);
          });
        }
      });
    },
  },
  watch: {
    'value.options': {
      handler(options) {
        this.$store.commit('settings/TABLE_ITEMS_UPDATE', {
          tableName: 'userList',
          itemsPerPage: options.itemsPerPage,
        });
        this.$emit('onChangeOptions', this.value);
      },
    },
  },
};
</script>
